import React, { useCallback } from 'react';
import classNames from 'classnames';
import CheckcircleIcon from 'icons/Checkcircle.icon';
import SelectCustomOptions from 'components/SelectCustomOptions';
import { useTranslation } from 'react-i18next';

import './QaRolesCustomSelect.styles.scss';
import './QaRolesCustomSelect.styles.responsive.scss';

export type OptionType = {
  value: string;
  props: QARoleSelectOptionProps;
};

export type QARoleSelectOptionProps = {
  className?: string;
  title: string;
  description: string;
};

export const QARoleSelectOption: React.FC<QARoleSelectOptionProps> = ({
  title,
  description,
  className,
}) => {
  const classes = classNames('qa-role-select-option', className);
  return (
    <div className={classes}>
      <span>{title}</span>
      <span>{description}</span>
      <CheckcircleIcon />
    </div>
  );
};

type QaRolesCustomSelectProps = {
  className?: string;
  options: OptionType[];
  name: string;
  label: string;
  renderAsPortal?: boolean;
  value?: string;
  onChange: (value: Record<string, string>) => void;
};

const QaRolesCustomSelect: React.FC<QaRolesCustomSelectProps> = (props) => {
  const { className, options, name, label, renderAsPortal, value, onChange } =
    props;

  const { t } = useTranslation();

  const classes = classNames('qa-roles-custom-select', className);

  const hanldeOnChange = useCallback(
    (newValue: string) => {
      if (newValue !== value) onChange({ [name]: newValue });
    },
    [name, value, onChange],
  );

  return (
    <div className={classes}>
      <label className="required">{label}</label>
      <SelectCustomOptions
        options={options.map(({ value, props }) => ({
          value,
          renderedOption: <QARoleSelectOption {...props} />,
        }))}
        value={value}
        renderAsPortal={renderAsPortal}
        onChange={hanldeOnChange}
        renderedTrigger={
          value ? (
            <span>
              {options.find((opt) => opt.value === value)?.props.title}
            </span>
          ) : (
            t('chooseRole')
          )
        }
      />
    </div>
  );
};

export default QaRolesCustomSelect;
